import { useSavedRecommendations } from '../hooks/useDiscovery';
import { RecommendationCard } from '../components/RecommendationCard';

export function SavedRecommendations() {
  const { saved, loading, error, unsave } = useSavedRecommendations();

  return (
    <div className="container py-12">
      <div className="max-w-5xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Mis recomendaciones guardadas</h1>
          <p className="text-gray-600 mt-1">Tus lugares favoritos guardados para después</p>
        </div>

        {loading && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="card">
                <div className="skeleton aspect-video w-full" />
                <div className="p-4 space-y-3">
                  <div className="skeleton h-6 w-3/4" />
                  <div className="skeleton h-4 w-full" />
                  <div className="skeleton h-4 w-2/3" />
                </div>
              </div>
            ))}
          </div>
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm mb-6">
            {error}
          </div>
        )}

        {!loading && !error && saved.length === 0 && (
          <div className="text-center py-20">
            <svg className="mx-auto h-16 w-16 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
            </svg>
            <h3 className="mt-4 text-xl font-semibold text-gray-900">No tienes recomendaciones guardadas</h3>
            <p className="mt-2 text-gray-600">Cuando guardes una recomendación, aparecerá aquí</p>
            <a href="/" className="mt-6 inline-block btn-primary">
              Explorar lugares
            </a>
          </div>
        )}

        {!loading && !error && saved.length > 0 && (
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {saved.map((entry) =>
              entry.recommendation ? (
                <li key={entry.recommendation.id} className="relative">
                  <RecommendationCard recommendation={entry.recommendation} />
                  <button
                    type="button"
                    onClick={() => unsave(entry.recommendationId)}
                    aria-label={`Quitar ${entry.recommendation?.title ?? 'recomendación'} de guardados`}
                    className="absolute top-2 right-2 w-8 h-8 rounded-full bg-gray-900/70 text-white flex items-center justify-center hover:bg-gray-900 transition-colors"
                  >
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </li>
              ) : null
            )}
          </ul>
        )}
      </div>
    </div>
  );
}